export class UserPreferenceModel {
setValue(res){
if(res){
}
}
}